import React from "react";

const RotateLeft = ({ style = {}, size = "18", className = "", fill = "#73788B", viewBox = "0 0 24 24" }) => (
    <svg 
    width={size}
    style={style}
    height={size}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink">
        <path
            className="u_fill-stroke"
            stroke={fill}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M1 4v6h6"
        />
        <path
            className="u_fill-stroke"
            stroke={fill}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3.51 15a9 9 0 1 0 2.12-9.36L1 10"
        />
    </svg>
);

export default RotateLeft;
